import SubscriptionPlan from "../types/enums/SubscriptionPlan"

const SubscriptionPlanTitles: Record<SubscriptionPlan, string> = {
  [SubscriptionPlan.E_PLUS]: "E+",
  [SubscriptionPlan.CONNECT]: "Connect",
  [SubscriptionPlan.NETWORK]: "Network",
  [SubscriptionPlan.PLUS]: "Plus",
  [SubscriptionPlan.BASIC]: "Basic",
  [SubscriptionPlan.BASIC_MAY_2025]: "Basic May 2025",
  [SubscriptionPlan.GO]: "Go",
  [SubscriptionPlan.SUPREME]: "Supreme",
  [SubscriptionPlan.BASIC_OCT_2025]: "Basic October 2025",
  [SubscriptionPlan.BASIC_DEC_2025]: "Basic December 2025",
  [SubscriptionPlan.GROWTH]: "Grow",
  [SubscriptionPlan.GROW_MARCH_2026]: "Grow March 2026",
}

export const OldSubscriptionPlanTitles: Record<SubscriptionPlan, string> = {
  ...SubscriptionPlanTitles,
  [SubscriptionPlan.BASIC_MAY_2025]: "Basic",
  [SubscriptionPlan.BASIC_OCT_2025]: "Basic",
  [SubscriptionPlan.BASIC_DEC_2025]: "Basic",
  [SubscriptionPlan.GROW_MARCH_2026]: "Grow",
}

export default SubscriptionPlanTitles
